module.exports = __webpack_public_path__ + "static/media/node.4e6a0c98.png";